import React, { Component } from "react"
import helper from "../../../../utils/helper"

class CardPlanos extends Component {
    render(){
        const { data, periodoDeFaturamento, periodoDeFaturamentoString } = this.props
        const isSobDemanda = data.tipo_plano === 'sob_demanda'

        return (
            <div className="container-default" style={{width: "calc((100% / 2) - 5px)", padding: "20px", position: "relative"}}>

                <div className="d-flex align-items-center justify-content-between">
                    <div style={{ backgroundColor: "rgb(243, 232, 255)", padding: "3px 14px", borderRadius: "5px" }}>
                        <span style={{ fontWeight: "bold", color: "rgb(147, 51, 234)" }}>{data.plano}</span>
                    </div>
                    <div className="d-flex flex-column align-items-end">
                        {isSobDemanda ? (
                            <><span style={{ fontWeight: "bold" }}>Sob Demanda</span></>
                        ) : (
                            <>
                                <span style={{ fontWeight: "bold" }}>{ helper.formatMoney(data.valor) }</span>
                                <span style={{ color: "rgb(151, 151, 151)", fontWeight: "bold" }}>{data.cobranca}</span>
                            </>
                        )}
                    </div>
                </div>

                <div className="d-flex mt-2 justify-content-between">
                    <div className="d-flex flex-column align-items-start justify-content-between">
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{ helper.formatMoney(data.total_de_faturamento) }</span>
                        <span style={{ color: "rgb(151, 151, 151)", fontWeight: "bold" }}>Faturamento total</span>
                    </div>
                    {isSobDemanda ? (
                        <div className="d-flex">
                            <div className="d-flex flex-column ml-4">
                                <span style={{ fontWeight: "bold", fontSize: "12px" }}>{helper.formatMoney(data.valor_mensagem)}</span>
                                <span style={{ color: "rgb(151, 151, 151)", fontWeight: "bold" }}>Mensagem</span>
                            </div>
                            <div className="d-flex flex-column ml-4">
                                <span style={{ fontWeight: "bold", fontSize: "12px" }}>{helper.formatMoney(data.valor_dispositivo)}</span>
                                <span style={{ color: "rgb(151, 151, 151)", fontWeight: "bold" }}>Dispositivo</span>
                            </div>
                            <div className="d-flex flex-column ml-4">
                                <span style={{ fontWeight: "bold", fontSize: "12px" }}>{helper.formatMoney(data.valor_dados_trafegados)}</span>
                                <span style={{ color: "rgb(151, 151, 151)", fontWeight: "bold" }}>Dados</span>
                            </div>
                        </div>
                        ) : (
                            null
                        )}
                </div>

                <div className="d-flex justify-content-between" style={{margin: "20px 0px 40px 0px"}}> 
                    <div className="d-flex flex-column">
                        <span style={{ color: "rgb(151, 151, 151)", fontWeight: "bold" }}>Clientes selecionados</span>
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{data.quantidade_de_clientes_selecionados}</span>
                    </div>
                    <div className="d-flex flex-column"> 
                        <span style={{ color: "rgb(151, 151, 151)", fontWeight: "bold" }}>Média por cliente</span>
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>{ helper.formatMoney(data.media_de_faturamento_por_cliente) }</span>
                    </div>
                </div>

                {isSobDemanda && (
                    <div className="d-flex justify-content-between" style={{ fontSize: "12px", marginTop: "-20px", marginBottom: "40px" }}>
                        <div className="d-flex flex-column">
                            <span style={{ color: "rgb(151, 151, 151)" }}>Faturamento Mensagens</span>
                            <span style={{ fontWeight: "bold" }}>{ helper.formatMoney(data.total_de_faturamento_mensagens) }</span>
                        </div>
                        <div className="d-flex flex-column">
                            <span style={{ color: "rgb(151, 151, 151)" }}>Faturamento Dispositivos</span>
                            <span style={{ fontWeight: "bold" }}>{ helper.formatMoney(data.total_de_faturamento_dispositivos) }</span>
                        </div>
                        <div className="d-flex flex-column">
                            <span style={{ color: "rgb(151, 151, 151)" }}>Faturamento Dados</span>
                            <span style={{ fontWeight: "bold" }}>{ helper.formatMoney(data.total_de_faturamento_dados_trafegados) }</span>
                        </div>
                    </div>
                )}

                <div 
                    className="d-flex justify-content-between align-items-center"
                    style={{ 
                        width: "100%", 
                        height: "40px",
                        padding: "0px 20px", 
                        backgroundColor: "#f9fafb", 
                        position: "absolute",
                        left: "0px",
                        top: "calc(100% - 40px)",
                        borderBottomLeftRadius: "10px",
                        borderBottomRightRadius: "10px"
                    }}
                > 
                    <span style={{ fontWeight: "bold" }}>Faturamento {periodoDeFaturamentoString}</span>
                    <span style={{ fontWeight: "bold" }}>{ helper.formatMoney(data[`total_de_faturamento_por_${periodoDeFaturamento}`]) }</span>
                </div>
            </div>
        )
    }
}

export default CardPlanos